import React from 'react';
import {
  Layout as DefaultLayout,
  LayoutProps,
} from 'tenants/_template/desktop/_module/Layout';
import { NotiConsentContextProvider } from '../../_contexts/NotiConsentContext';

export const Layout: React.FunctionComponent<LayoutProps> = ({
  children,
  ...props
}: LayoutProps) => {
  return (
    <NotiConsentContextProvider>
      <DefaultLayout {...props}>{children}</DefaultLayout>
    </NotiConsentContextProvider>
  );
};
